function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 10"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm10 12a9.953 9.953 0 01-2.26 6.325L13.413 12l6.325-6.325A9.953 9.953 0 0122 12zm-9-2.414V2.05a9.955 9.955 0 015.325 2.21zM2 12a10.015 10.015 0 019-9.95v9.536l-6.74 6.74A9.953 9.953 0 012 12zm3.675 7.74L12 13.413l6.325 6.325a9.979 9.979 0 01-12.65 0z"
})));